var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCallingShow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.378,
    height: 23.376,
    viewBox: "0 0 23.378 23.376",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Calling",
    d: "M15.335,22.729C10.32,20.635,2.66,13.127.635,8.15-.206,6.3-.212,4.77.62,3.622.952,3.083,2.844.833,4.537.9a2.176,2.176,0,0,1,1.319.69A15.438,15.438,0,0,1,8.483,5.242,2.612,2.612,0,0,1,7.99,7.135c-.313.547-1.148,1.583-.931,2.187a13.438,13.438,0,0,0,7.122,6.92c.591.215,1.626-.62,2.17-.935a2.586,2.586,0,0,1,1.888-.5,15.619,15.619,0,0,1,3.638,2.681,2.167,2.167,0,0,1,.684,1.31c.063,1.733-2.291,3.71-2.719,3.956a3.307,3.307,0,0,1-1.976.616A6.072,6.072,0,0,1,15.335,22.729Zm2-13.46h0a4.047,4.047,0,0,0-3.207-3.215,1.006,1.006,0,0,1,.382-1.976,6.05,6.05,0,0,1,4.793,4.8,1.011,1.011,0,0,1-.792,1.183,1.079,1.079,0,0,1-.193.017A1,1,0,0,1,17.339,9.269Zm4.04-.086a8.08,8.08,0,0,0-7.16-7.175A1.006,1.006,0,0,1,13.334.9a1,1,0,0,1,.377-.683.956.956,0,0,1,.731-.206,10.072,10.072,0,0,1,8.929,8.95,1,1,0,0,1-.212.74.99.99,0,0,1-.671.371.974.974,0,0,1-.114.007A1,1,0,0,1,21.38,9.183Z",
    transform: "translate(0 0)",
    fill: "#191919"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallingShow);
export default __webpack_public_path__ + "static/media/CallingShow.bf91118fe765d7483b70b17100af1979.svg";
export { ForwardRef as ReactComponent };